export default __webpack_public_path__ + "static/media/McMaster Divinity College.b1c4bb88.jpg";